<template>
  <v-snackbar
    v-model="snackbar.isShown"
    timeout="-1"
    :color="snackbar.isSuccess ? 'success' : 'error'"
  >
    {{ snackbar.message }}

    <template v-slot:action="{ attrs }">
      <v-btn
        color="secondary"
        icon
        v-bind="attrs"
        @click="snackbar.isShown = false"
      >
        <v-icon color="primary">{{ icons.mdiClose }}</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mdiClose } from '@mdi/js'

export default {
  name: 'GlobalSnackbar',
  data () {
    return {
      snackbar: {
        isShown: false,
        message: '',
        isSuccess: true,
      },
      icons: {
        mdiClose,
      },
    }
  },
  mounted () {
    this.$root.$on('snackbar', this.showSnackbar)
  },
  beforeDestroy () {
    this.$root.$off('snackbar', this.showSnackbar)
  },
  methods: {
    showSnackbar ({ message, isSuccess = true }) {
      this.snackbar.message = message
      this.snackbar.isSuccess = isSuccess
      this.snackbar.isShown = true
    },
  },
}
</script>
